import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import {
  fetchRoles, showSaveRole, toggleRolesPresentation, updateRolesFilter,
} from '../actions';

const RolesPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-roles-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  roles: { roles },
}, { category, displayAs }) => {
  const item = roles[category];
  return {
    canRead: permissions.roles.read,
    canCreate: permissions.roles.create,
    currentPage: item.currentPage,
    display: displayAs || item.display,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    roles: item.results,
    total: item.count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchRoles,
  newRole: () => showSaveRole(null, null),
  togglePresentation: toggleRolesPresentation,
  updateFilterTerm: updateRolesFilter,
};

export default RolesPanelContainer;
